import { Alert, Box, Button, Card, CardContent, Container, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChangePassword } from '../../features/auth/queries';
import { extractError } from '../../shared/api';
import { useAuthStore } from '../../features/auth/store';

export default function ChangePasswordPage() {
  const [oldPassword, setOld] = useState('');
  const [newPassword, setNew] = useState('');
  const [confirm, setConfirm] = useState('');
  const change = useChangePassword();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirm) return;
    change.mutate({ oldPassword, newPassword }, {
      onSuccess: () => navigate('/portal'),
    });
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Card>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {user?.mustResetPassword ? 'Change your password' : 'Update password'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {user?.mustResetPassword
              ? 'For your security, please change the default password before continuing.'
              : 'Choose a new strong password.'}
          </Typography>
          <Box component="form" onSubmit={onSubmit} sx={{ mt: 3 }}>
            <Stack spacing={2}>
              <TextField label="Current password" type="password" value={oldPassword} onChange={(e) => setOld(e.target.value)} required />
              <TextField label="New password" type="password" value={newPassword} onChange={(e) => setNew(e.target.value)} required helperText="Minimum 6 characters" />
              <TextField
                label="Confirm new password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                error={!!confirm && confirm !== newPassword}
                helperText={confirm && confirm !== newPassword ? 'Passwords do not match' : ''}
                required
              />
              {change.isError && <Alert severity="error">{extractError(change.error)}</Alert>}
              {change.isSuccess && <Alert severity="success">Password changed.</Alert>}
              <Button type="submit" variant="contained" disabled={change.isPending || newPassword !== confirm}>
                {change.isPending ? 'Updating…' : 'Update password'}
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
